import { GridAction } from '@eforall/dashboard';
import { Trimester } from '@interfaces';

export function getActions() {

	const actions: GridAction<Trimester>[] = [
	];

	return actions;
}